:host {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.biel-chat-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  /* The chat pins its own scroll position; browser scroll anchoring fights
     the per-chunk re-render during streaming and fires spurious scroll
     events that read as the user scrolling up. */
  overflow-anchor: none;
  padding: 10px 10px 16px;
  gap: 16px;
  transition: all 0.3s ease-in-out;
}

.biel-chat-container--embedded {
  min-height: var(--biel-chat-embedded-height);
}

.biel-chat-container::-webkit-scrollbar {
  width: 6px;
}

.biel-chat-container::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 10px;
  border: 3px solid transparent;
  transition: background-color 0.3s ease;
}

/* Show scrollbar only while user is scrolling */
.biel-chat-container.is-scrolling::-webkit-scrollbar-thumb {
  background-color: var(--biel-chat-scrollbar-color);
}

.biel-chat-container.is-scrolling::-webkit-scrollbar-thumb:hover {
  background-color: var(--biel-chat-scrollbar-hover-color);
}

/* Keep it hidden while AI is streaming */
.biel-chat-container.is-streaming::-webkit-scrollbar,
.biel-chat-container.is-streaming::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.loading-animation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin-top: 10px;
}

.loading-animation .dot {
  width: 8px;
  height: 8px;
  margin: 0 5px;
  background-color: var(--biel-text-color);
  border-radius: 50%;
  animation: bounce 1.2s infinite ease-in-out;
}

.loading-animation .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-animation .dot:nth-child(2) {
  animation-delay: -0.16s;
}

.loading-animation .dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

.biel-continue-button-container {
  display: flex;
  margin-top: 10px;
}

.biel-continue-button {
  background-color: var(--biel-continue-button-bg-color);
  color: var(--biel-continue-button-color);
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

@media (hover: hover) {
  .biel-continue-button:hover {
    background-color: var(--biel-continue-button-bg-color-hover);
  }
}

